export class HeatMapFontManagerParams {
}
